import { Route, Routes } from "react-router-dom";
import ProductCategories from "view/productcategories/ProductCategories";
import ProductCategoryCreateEdit from "view/productcategories/ProductCategoryCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<ProductCategories />} />
			<Route path='/create' element={<ProductCategoryCreateEdit />} />
			<Route path='/:id/edit' element={<ProductCategoryCreateEdit />} />
		</Routes>
	);
};

export default index;
